module.exports = __webpack_public_path__ + "static/img/3DBG.2ad475a.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/3D/3DBG.png
// module id = ptnL
// module chunks = 202